import { request, Row, Rows } from './request';
import AppError from './models/common/res/AppError';
import { PhoneAuthBody } from './models/auth/req/PhoneAuthBody';
import { PhoneAuthRes } from './models/auth/res/PhoneAuthRes';
import { Terms } from './models/auth/res/Terms';
import { ValidatePhoneAuthNoBody } from './models/auth/req/ValidatePhoneAuthNoBody';
import { ValidatePhoneAuthNoRes } from './models/auth/res/ValidatePhoneAuthNoRes';
import { GuestSignInBody } from './models/auth/req/GuestSignInBody';
import { sendLoginEvent } from '../utils/gtm-utils';
import { sendLoginEvent as sendLoginEventByGA } from '../utils/ga-utils';
import moment from 'moment/moment';
import { ChatbotGuestSignInBody } from './models/auth/req/ChatbotGuestSignInBody';
import LANGUAGE_MAPPER from '../constants/language-mapper.constants';
import { CustomerPartnerTermsDto } from './terms';

export const requestValidatePhoneAuthNo = async (
  body: ValidatePhoneAuthNoBody,
) => {
  const url = `/access-tokens`;
  try {
    const { data } = await request<Row<ValidatePhoneAuthNoRes>>({
      method: 'post',
      url,
      requestBody: {
        type: 'message',
        kind: '로그인 인증',
        ...body,
      },
    });
    const { row } = data;
    return row;
  } catch (e) {
    throw new AppError(e);
  }
};

export const requestPhoneAuth = async (
  partnerCode: string,
  body: PhoneAuthBody,
) => {
  const url = `/mini-web/partner-customer/${partnerCode}/auth-tokens`;
  try {
    const { data } = await request<Row<PhoneAuthRes>>({
      method: 'post',
      url,
      requestBody: {
        type: 'message',
        kind: '로그인 인증',
        ...body,
      },
    });
    const { row } = data;
    return row;
  } catch (e) {
    throw new AppError(e);
  }
};

export const guestSignIn = async (body: GuestSignInBody) => {
  const url = `/mini-web/partner-customer/sign-in`;
  try {
    const { data } = await request<Row<any>>({
      method: 'post',
      url,
      requestBody: body,
      queryParams: {
        noCache: moment().format('YYYYMMDDHHmmss'),
      },
    });
    sendLoginEvent();
    sendLoginEventByGA();

    return { token: data.row.token, partnerCustomerId: data.row.id };
  } catch (e) {
    throw new AppError(e);
  }
};

export const chatbotGuestSignIn = async (body: ChatbotGuestSignInBody) => {
  const url = `/mini-web/partner-customer/chatbot/sign-in`;
  try {
    const { data } = await request<Row<any>>({
      method: 'post',
      url,
      requestBody: body,
    });

    return { token: data.row.token, partnerCustomerId: data.row.id };
  } catch (e) {
    throw new AppError(e);
  }
};

export const fetchLegacyTerms = async (
  partnerCode: string,
  languageCode?: string,
) => {
  const url = `/terms/${partnerCode}`;
  try {
    let mappedLanguageCode = languageCode;
    if (languageCode && LANGUAGE_MAPPER[languageCode]) {
      mappedLanguageCode = LANGUAGE_MAPPER[languageCode];
    }

    const { data } = await request<Rows<Terms>>({
      method: 'get',
      url,
      queryParams: {
        target: 'CUSTOMER',
        languageCode: mappedLanguageCode,
      },
    });
    const { rows } = data;
    return rows;
  } catch (e) {
    throw new AppError(e);
  }
};

export const fetchTerms = async (
  partnerCode: string,
  languageCode?: string,
) => {
  const url = `/customer/partner-terms/${partnerCode}`;

  try {
    let mappedLanguageCode = languageCode;
    if (languageCode && LANGUAGE_MAPPER[languageCode]) {
      mappedLanguageCode = LANGUAGE_MAPPER[languageCode];
    }

    const { data } = await request<Rows<CustomerPartnerTermsDto>>({
      method: 'get',
      url,
      queryParams: {
        platform: 'WEB',
        languageCode: mappedLanguageCode,
      },
    });

    return data?.rows;
  } catch (e) {
    throw new AppError(e);
  }
};
